import { Box } from '@mantine/core';
import { IconPointFilled as EvaluationIcon } from '@tabler/icons-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { OpenEvaluationBox } from '@/module/Evaluation/components/OpenEvaluationBox';
import { getEvaluationsOptions } from '@/module/Evaluation/model/EvaluationQuery';

import { NoContentPlaceholder } from '@/core/components';
import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

import { useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/evaluation/_layout')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.evaluation' },
  },
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getEvaluationsOptions());
  },
});

function RouteComponent() {
  const { data } = useSuspenseQuery(getEvaluationsOptions());
  const { currentRole } = useCurrentUser();
  const currentEvaluationYear = new Date().getFullYear() - 1;

  const currentEvaluationOpen = data.filter(ev => ev.year === currentEvaluationYear).length > 0;

  const tabs = data.map(evaluation => ({
    label: `Evaluare ${evaluation.year}`,
    to: `/evaluation/${evaluation.id}`,
    icon: EvaluationIcon,
  }));

  return (
    <Box p="md">
      {!currentEvaluationOpen && currentRole === 'UNIVERSITY_ADMIN' && (
        <Box mb="15px">
          <OpenEvaluationBox year={currentEvaluationYear} />
        </Box>
      )}
      {data?.length > 0 && (
        <>
          <ContextSidebar
            baseUrl=""
            items={tabs}
          />
          <Outlet />
        </>
      )}
      {data?.length === 0 && (
        <NoContentPlaceholder title="Nu a fost deschis pentru raportare nici un raport de evaluare anuală" />
      )}
    </Box>
  );
}
